import { AuthService } from 'src/app/services/auth.service';
import { FormBuilder } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { Call } from 'src/app/models/call.model';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { MgService } from 'src/app/services/mg.service';
import { Item } from 'src/app/models/item.model';
import { MatDialog } from '@angular/material/dialog';
import { OpenOsDialogComponent } from '../../open-os-dialog/open-os-dialog.component';

@Component({
  selector: 'app-call-new-entry',
  templateUrl: './call-new-entry.component.html',
  styleUrls: [
    './call-new-entry.component.scss',
    './../../../../assets/scss/call-screen.scss',
  ]
})
export class CallNewEntryComponent implements OnInit {
  @Input() call: Call;
  @Input() origin: "C" | "A";
  @Input() operator: boolean = false;

  @Output() newEntry: EventEmitter<any> = new EventEmitter();
  @Output() newFiles: EventEmitter<any> = new EventEmitter();

  public entryEditor = ClassicEditor;
  public description: string = "";
  public saving: boolean = false;
  public typeResponse: string = 'R';
  public limitDate: string = null;

  private files: any[];
  public _isLoading: boolean = false;

  constructor(
    private api: MgService,
    private auth: AuthService,
    private dialog: MatDialog,
    private snack: MatSnackBar
  ) { }

  ngOnInit(): void {
  }

  public saveEntry(): void {
    this.saving = true;
    let item = new Item;
    item.call_id = 0;
    item.description = this.description;
    item.origin = this.origin;
    item.type = this.typeResponse;
    item.limit_date = this.limitDate;

    if(this.description == null || this.description == '') {
      this.saving = false;
      this.snack.open('A resposta não pode ficar em branco!', 'Fechar', {
        duration: 3000
      });
      return;
    }

    this.api.postCallItem(this.call.identifier, item)
      .subscribe(
        res => {
          this.newEntry.emit(res.data)
          this.description = "";
          this.saving = false;
          if(this.files && this.files.length > 0) {
            this.saving = true;
            this.sendCallFiles(res.data.id);
          }
        },
        err => {
          console.error(err)
          this.saving = false;
        }
      )
  }

  private sendCallFiles(call_entry_id: number) {
    let form = new FormData();

    form.append('call_entry_id', call_entry_id.toString());
    form.append('call_id', this.call.id.toString());
    form.append('path', 'public/mhelp');
    for (let index = 0; index < this.files.length; index++) {
      form.append(`files[${index}]`, this.files[index]);
    }

    this.api.postCallFiles(form, this.operator)
      .subscribe(
        res => {
          this.newFiles.emit(true)
          this.files = null;
          this.saving = false;
        },
        err => {
          console.error(err)
        }
      );
  }

  public cancelEntry(): void {
    this.description = "";
  }

  public openOsCreation(): void {
    const dialogRef = this.dialog.open(OpenOsDialogComponent, {
      data: { call: this.call }
    });
  }

  public filesIncuded(files: any) {
    this.files =  Array.from(files);
  }

  get filesToUpload(): any{
    return this.files;
  }

  public removeFile(file) {
    this.files = this.files.filter(item => item != file);
  }
}
